import * as React from "react";
import IconEditorial from "../icon-editorial/icon-editorial";
import Slider, { Settings } from "react-slick";
import { currentMediaQueries, Breakpoints } from "../../utils/breakpoint-utils";
import { debounce } from "../../utils/function-utils";

interface IIconTextBarItem {
    svgCodeSmallIcon?: string;
    svgCodeLargeIcon?: string;
    richText: string;
}

export interface IIconTextBarProps {
    iconTextBarItems: IIconTextBarItem[];
    bgColor?: string;
    textColor?: string;
}

interface IConfig {
    numberSlides: number;
    mediaQuery?: Breakpoints;
}

interface IIconTextBarState {
    config: IConfig;
}

class IconTextBar extends React.Component<IIconTextBarProps, IIconTextBarState> {
    public state = {
        config: {
            numberSlides: 1
        }
    };

    private configs: IConfig[] = [
        {
            mediaQuery: "dogMin",
            numberSlides: 3
        },
        {
            mediaQuery: "catMin",
            numberSlides: 2
        },
        {
            mediaQuery: "ratMin",
            numberSlides: 1
        },
        {
            mediaQuery: "ratMax",
            numberSlides: 1
        }
    ];

    private defaultConfig = {
        numberSlides: 1
    };

    public componentDidMount() {
        window.addEventListener("resize", this.handleResize.bind(this));
        this.setConfig();
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize.bind(this));
    }

    public handleResize = debounce(this.setConfig, 50);

    public setConfig() {
        this.setState({
            config: this.getConfig()
        });
    }

    public getConfig() {
        const currentConfig = this.configs.find(config => {
            return config.mediaQuery && currentMediaQueries[config.mediaQuery];
        });

        return currentConfig || this.defaultConfig;
    }

    public render() {
        const baseClass = "icon-text-bar";
        const { iconTextBarItems: iconTextList, bgColor, textColor } = this.props;
        const numberSlides = Math.min(this.state.config.numberSlides, iconTextList.length);

        const listItems = iconTextList.map((listItem, index) => {
            const { svgCodeSmallIcon, svgCodeLargeIcon, richText } = listItem;
            return (
                <div key={index}>
                    <div className={`${baseClass}__item-wrapper`}>
                        {(svgCodeLargeIcon || svgCodeSmallIcon) && (
                            <div className={`${baseClass}__icon`}>
                                <IconEditorial svgCodeLargeIcon={svgCodeLargeIcon || svgCodeSmallIcon} />
                            </div>
                        )}
                        <div
                            className={`${baseClass}__rich-text content-rich-text`}
                            dangerouslySetInnerHTML={{ __html: richText }}
                        />
                    </div>
                </div>
            );
        });

        const shouldAutoPlay = iconTextList.length > numberSlides;
        const params: Settings = {
            autoplay: shouldAutoPlay,
            infinite: shouldAutoPlay,
            slidesToShow: numberSlides,
            slidesToScroll: numberSlides,
            arrows: false,
            speed: 750
        };

        return (
            <section className={`${baseClass} theme-color-${textColor} theme-bg-${bgColor}`}>
                <div className={`${baseClass}__inner`}>
                    <Slider {...params} key={`${shouldAutoPlay}`}>
                        {listItems}
                    </Slider>
                </div>
            </section>
        );
    }
}

export default IconTextBar;
